import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook } from '@fortawesome/free-brands-svg-icons/faFacebook';
import toast from 'react-hot-toast';

import { FBLoginResponse } from 'us-web-services';
import { Button, ButtonType } from '../../components';
import { useDependencies } from '../../dependencies';
import { FacebookSdk } from 'us-react-components/dist/utils/FacebookSdk';

import { FacebookUtil } from '../../utils/FacebookUtil';

export const FacebookVerification = (): JSX.Element => {
  const { stores } = useDependencies();
  const { t } = useTranslation();
  const { verification } = stores;

  const callback = async (): Promise<void> => {
    await verification.getUserVerification();
    if (verification.isVerified() && verification.callback) {
      verification.callback();
    } else {
      toast.error(t('identityCheck.facebook.verificationFailed'));
    }
  }

  const handleLoginResponse = (facebookResponse: FBLoginResponse): void => {
    verification.loadingFacebook = false;
    FacebookUtil.linkFacebook(facebookResponse, stores.user, t, callback);
  }

  const handleFacebookClick = (): void => {
    verification.loadingFacebook = true;
    void (async (): Promise<void> => {
      try {
        const sdk = await FacebookSdk.ensureReady();

        sdk.login(handleLoginResponse);
      } catch {
        verification.loadingFacebook = false;
        toast.error(t('notifications.facebook.sdkUnavailable'));
      }
    })();
  }

  const getHeader = (): string => {
    if (!verification.stripeComplete() && !verification.stripeInProgress()
      && !verification.stripeProcessing()) {
      return t('identityCheck.facebook.headerNoStripeProgress');
    }
    return '';
  }

  const getDescription = (): string => {
    if (!verification.stripeComplete() && !verification.stripeInProgress()
      && !verification.stripeProcessing()) {
      return t('identityCheck.facebook.descriptionNoStripeProgress');
    } if (verification.stripeInProgress() && !verification.stripeProcessing()) {
      return t('identityCheck.facebook.descriptionStripeProgress');
    }
    return '';
  }

  return (
    <div className='flex justify-center mb-4 border-2 p-2 rounded-2xl md:w-[250px] md:h-[260px]'>
      <div className='mt-3'>
        <div className='font-bold text-xl mb-2'>{getHeader()}</div>
        <div className='mb-4'>
          {getDescription()}
        </div>
        <div className='text-center'>
          <Button
            buttonType={ButtonType.facebook}
            className='px-5 mb-4 min-w-[8rem]'
            onClick={handleFacebookClick}>
            <FontAwesomeIcon icon={faFacebook} size='xl' />
            &nbsp;&nbsp;{t('identityCheck.facebookButton')}
          </Button>
        </div>
      </div>
    </div>
  );
};
